import React, { useEffect, useState } from 'react';
import { getLiveStreamingUrlAPI } from '../../service/AuthService';
const LiveStreamPlayer = ({ eventId, height = 221, width = '100%' }) => {
  // const [channelId, setChannelId] = useState(null);
  // useEffect(() => {
  //   if (!eventId) return;
  //   const fetchChannelId = async () => {
  //     try {
  //       const response = await getLiveStreamingUrlAPI(eventId);
  //       if (response?.response) {
  //         setChannelId(response?.response);
  //       } else {
  //       }
  //     } catch (error) {
  //     }
  //   };
  //   fetchChannelId();
  // }, [eventId]);

  // if (!eventId) return <p className='text-black'>No Event ID provided.</p>;
  // if (!channelId) return <p className='text-black' style={{height : '221'}}>Loading stream...</p>;
  // const streamUrl = `https://video.proexch.in/tv/v2/hls.php?eventId=${eventId}`;
  const streamUrl = `https://video.proexch.in/tv/v4/stream/${eventId}`;
  return (
    <iframe
      src={streamUrl}
      width={width}
      height={height}
      frameBorder="0"
      allowFullScreen
      title={`Live Stream - ${eventId}`}
    />
  );
};

export default LiveStreamPlayer;